/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { observer } from 'mobx-react-lite';
import React, { useEffect, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Text, BoxProps } from 'theme-ui';
import { useStore } from '@utils/hooks';
import { ErrorContainer } from './styled';

/**
 * Ref prop is ommited here due to `Types of property 'ref' are incompatible`.
 * It is caused by incorrect use of the base type in theme-ui typings.
 */
type Props = Omit<BoxProps, 'ref'>;

export const AppNotifications: FunctionComponent<Props> = observer(({ children, ...props }) => {
  const { t } = useTranslation();
  const { notifications } = useStore();
  const { active } = notifications;
  const { item, open } = active;

  useEffect(() => notifications.showNextNotification());

  return open ? (
    <ErrorContainer p={0} mx="auto" role="alert" {...props}>
      {children}
      <Text variant="default" id="app-notification-message">
        {t(item?.message)}
      </Text>
    </ErrorContainer>
  ) : null;
});
